export const LogoShortIcon: React.FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5017_34594)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0203247 40.021V20.021C0.0203247 8.9753 8.97463 0.0209961 20.0203 0.0209961C31.066 0.0209961 40.0203 8.9753 40.0203 20.021C40.0203 31.0667 31.066 40.021 20.0203 40.021H0.0203247ZM20.0203 2.87804C10.5525 2.87804 2.87737 10.5532 2.87737 20.021V37.1639H20.0203C29.4881 37.1639 37.1633 29.4888 37.1633 20.021C37.1633 10.5532 29.4881 2.87804 20.0203 2.87804Z"
        fill="white"
      />
      <path
        d="M10.8004 29.2002L3.60041 36.4002"
        stroke="white"
        strokeWidth="2.88"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1702 11.2426C6.31349 16.0993 6.31349 23.9736 11.1702 28.8303C16.0269 33.687 23.9012 33.687 28.7579 28.8303C33.6146 23.9736 33.6146 16.0993 28.7579 11.2426C23.9012 6.38592 16.0269 6.38592 11.1702 11.2426Z"
        stroke="white"
        strokeWidth="2.88"
      />
      <path
        d="M19.3098 21.3455L19.3098 29.2"
        stroke="#67BF2B"
        strokeWidth="2.88"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3305 18.7088C22.9014 20.429 20.4666 20.6779 19.3096 20.691V19.9531C19.3475 18.4861 19.6197 16.2638 20.8257 14.8186C22.2549 13.0984 24.6935 12.8495 25.8504 12.8364C25.8844 14.1681 25.7672 16.9842 24.3305 18.7088Z"
        fill="#67BF2B"
        stroke="#67BF2B"
        strokeWidth="2.88"
        strokeLinejoin="round"
      />
      <path
        d="M17.6579 19.2924C19.0914 20.4357 19.2988 22.3836 19.3098 23.3091H18.6949C17.4724 23.2789 15.6204 23.0611 14.4161 22.0962C12.9826 20.9529 12.7752 19.002 12.7643 18.0765C13.874 18.0493 16.2208 18.143 17.6579 19.2924Z"
        fill="#67BF2B"
        stroke="#67BF2B"
        strokeWidth="2.88"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5017_34594">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
